







































import {Emit} from 'vue-property-decorator';
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Fournisseur} from '@/models';

import CrudFournisseurEdit from '@/components/Crud/Fournisseur/Edit.vue';

@Component({
	components: {
		CrudFournisseurEdit,
	}
})
export default class CrudFournisseurEditDialog extends Vue {
	@InOut({ type: Fournisseur  , isVModel: true }) private value!: Fournisseur;

	@Emit()
	private onSubmit(fournisseur: Fournisseur) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		if (this.value.id) 
		{
			if (
				this.$route.name !== 'fournisseur-show' ||
				this.$route.params["id"] !== this.value.id.toString()
			) {
				this.$router.push({name: 'fournisseur-show', params: { id : this.value.id.toString() }});
			}
		}
		this.value = null;
	}
}
